import { Injectable } from '@angular/core';
import { CanActivate, Router, CanActivateChild } from '@angular/router';
import { AngularFireAuth } from '@angular/fire/auth';
import { map } from 'rxjs/operators'
import { Observable } from 'rxjs';
@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate, CanActivateChild {
  constructor(private _router: Router,
    private afAuth: AngularFireAuth) { }

  canActivate(): Observable<boolean> {
    return this.afAuth.authState.pipe(
      map(user => {
        if (user) return true;
        this._router.navigate(['/home']);
        return false;
      })
    )
  }

  canActivateChild(): Observable<boolean> {
    return this.afAuth.authState.pipe(
      map(user => {
        if (user) return true;
        this._router.navigate(['/home']);
        return false;
      })
    )
  }
}
